// import { initializeApp } from 'firebase/app';
// import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// // Your Firebase config from Firebase console
// const firebaseConfig = {
//   apiKey: 'AIzaSyCH2vyaCcAmAIZ0dAm97mzp14yLcltzSyU',
//   appId: '1:302676081555:web:5807814b02411b78e34666',
//   messagingSenderId: '302676081555',
//   projectId: 'promotions-vyh3489',
//   authDomain: 'promotions-vyh3489.firebaseapp.com',
//   storageBucket: 'promotions-vyh3489.appspot.com',
//   measurementId: 'G-JZB4CB16ZN',
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const messaging = getMessaging(app);

// // Function to get the FCM token
// export const getFcmToken = async () => {
//   try {
//     const token = 'eu0Svu_5SNuc7w2gzc9rGG:APA91bEY8uFwwMe55vhFQ4IAGOpv4kstDalTHM7g1_DB6OmoGbG6-87L-k2sCRNB3PCtGqQ6DMwP6j3A_twpAXZRiWSETEEqoZEU7FMc0OOC2WsL9mc7sJQ';
//     if (token) {
//       console.log('FCM Token:', token);
//       return token;
//     } else {
//       console.error('No FCM token found.');
//       return null;
//     }
//   } catch (error) {
//     console.error('Error getting FCM token:', error);
//     return null;
//   }
// };

// // Improved onMessageListener to handle notification payloads
// export const onMessageListener = () =>
//   new Promise((resolve, reject) => {
//     try {
//       onMessage(messaging, (payload) => {
//         console.log('Message received: ', payload);
        
//         // Check if notification exists in payload
//         const notification = payload?.notification;

//         if (notification) {
//           console.log('Notification title: ', notification.title);
//           console.log('Notification body: ', notification.body);
          
//           // Resolve with payload or notification data
//           resolve({
//             title: notification.title,
//             body: notification.body,
//             payload, // Full payload data for further processing
//           });
//         } else {
//           reject(new Error('No notification in the payload.'));
//         }
//       });
//     } catch (error) {
//       console.error('Error in onMessage listener:', error);
//       reject(error); // Reject promise in case of error
//     }
//   });

// // Exporting messaging instance for other uses
// export { messaging };



// Firebase Cloud Messaging Configuration File. 
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';


var firebaseConfig = {
  apiKey: 'AIzaSyCH2vyaCcAmAIZ0dAm97mzp14yLcltzSyU',
  appId: '1:302676081555:web:5807814b02411b78e34666',
  messagingSenderId: '302676081555',
  projectId: 'promotions-vyh3489',
  authDomain: 'promotions-vyh3489.firebaseapp.com',
  storageBucket: 'promotions-vyh3489.appspot.com',
  measurementId: 'G-JZB4CB16ZN',
};

initializeApp(firebaseConfig);

const messaging = getMessaging();

export const requestForToken = () => {
  return getToken(messaging, { vapidKey: 'BAM1KCiMzYRHAV1DQs7HJrfXPW5dr4aY37CSLSPJVyPtaeUnEL8hKnSg95aY63cHKfCK69jggpDMJx08AzEdh8g' })
    .then((currentToken) => {
      if (currentToken) {

        if(!localStorage.getItem('device_token')) {
          localStorage.setItem('new_token', 'true');
        } else if(localStorage.getItem('device_token') !== currentToken) {
          localStorage.setItem('new_token', 'true');
        }       
        localStorage.setItem('device_token', currentToken);
        console.log(currentToken);
        
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });

    
};



// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker `messaging.onBackgroundMessage` handler.
export const onMessageListener = () =>
  new Promise((resolve) => {    
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

  
